import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import ProfitabilitySearchBox from './components/ProfitabilitySearchBox';
import { getProfitabilityTableHeaders } from './helpers/getTableHeaders';
import { getProfitabilityTableRows } from './helpers/getTableRows';
import useProfitabilityReport from './hooks/useProfitabilityReport';

const ProfitabilityReport = () => {
	const hook = useProfitabilityReport();

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<h1>Profitability Report</h1>
				<ProfitabilitySearchBox
					handleSearchCallback={hook.fetchProfitabilityData}
				></ProfitabilitySearchBox>
				{hook.displayedRows && (
					<Table
						className='styled-table'
						raws={getProfitabilityTableRows(hook.displayedRows)}
						headers={getProfitabilityTableHeaders(hook.sortTableBy)}
					/>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default ProfitabilityReport;
